<template>
  <div class="row" style="margin-top: 20px">
    <div class="col-md-12 text-center">
      <div class="d-flex justify-content-center" role="group" aria-label="Basic example">
        <button type="button" style="margin-right:5px" class="btn btn-sm" v-bind:class="{ 'btn-secondary': abaSelecionada=='usuarios','btn-outline-secondary': abaSelecionada!=='usuarios' }" @click="trocarAba('usuarios')">Usuarios</button>
        <button type="button" style="margin-right:5px" class="btn btn-sm" v-bind:class="{ 'btn-secondary': abaSelecionada=='planos','btn-outline-secondary': abaSelecionada!=='planos' }" @click="trocarAba('planos')">Planos</button>
        <button v-if="retornaSite() == '7live'" type="button" style="margin-right:5px" class="btn btn-sm" v-bind:class="{ 'btn-secondary': abaSelecionada=='creditos-lancamentos','btn-outline-secondary': abaSelecionada!=='creditos-lancamentos' }" @click="trocarAba('creditos-lancamentos')">Creditos Lan.</button>
        <button type="button" style="margin-right:5px" class="btn btn-sm" v-bind:class="{ 'btn-secondary': abaSelecionada=='planos-lancamentos','btn-outline-secondary': abaSelecionada!=='planos-lancamentos' }" @click="trocarAba('planos-lancamentos')">Planos Lan.</button>
        <button v-if="retornaSite() == '7live'" type="button" class="btn btn-sm" v-bind:class="{ 'btn-secondary': abaSelecionada=='eventos-lancamentos','btn-outline-secondary': abaSelecionada!=='eventos-lancamentos' }" @click="trocarAba('eventos-lancamentos')">Eventos Lan.</button>
        <button v-if="retornaSite() == '7live'" type="button" style="margin-left:5px" class="btn btn-sm" v-bind:class="{ 'btn-secondary': abaSelecionada=='planos-finalizados','btn-outline-secondary': abaSelecionada!=='planos-finalizados' }" @click="trocarAba('planos-finalizados')">Comissão</button>
      </div>
      <div v-bind:style="{display: (abaSelecionada=='usuarios' ? 'block' : 'none')}" >
        <ListUsuarios />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='planos' ? 'block' : 'none')}" >
        <ListPlanos />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='creditos-lancamentos' ? 'block' : 'none')}" >
       <ListCreditosUsuario ref="listCreditosUsuario" :propView="'completo'" style="margin-top:30px" />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='planos-lancamentos' ? 'block' : 'none')}" >
       <ListPlanosCliente ref="listPlanosCliente" :propView="'completo'" style="margin-top:30px" />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='eventos-lancamentos' ? 'block' : 'none')}" >
       <ListEventosUsuario ref="listEventosUsuario" :propView="'completo'" style="margin-top:30px" />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='planos-finalizados' ? 'block' : 'none')}" >
       <ListPlanosFinalizados ref="listPlanosFinalizados" :propView="'completo'" style="margin-top:30px" />
      </div>

    </div>
  </div>
</template>

<script>
import ListUsuarios from "../lists/ListUsuarios";
import ListPlanos from "../lists/ListPlanos";
import ListPlanosCliente from "../lists/ListPlanosCliente";
import ListPlanosFinalizados from "../lists/ListPlanosFinalizados";
import ListCreditosUsuario from "../lists/ListCreditosUsuario";
import ListEventosUsuario from "../lists/ListEventosUsuario";


export default {
  name: "Administracao",
  components: { ListUsuarios, ListPlanos, ListPlanosCliente,ListPlanosFinalizados, ListCreditosUsuario, ListEventosUsuario },
  methods: {
    trocarAba(aba) {
      this.abaSelecionada = aba;
    },
    retornaSite()
    {
      return this.$site;
    }
  },
  data: function () {
    return {
      abaSelecionada: "resumo",
      isAdmin:false
    };
  },
  async mounted(){

    this.isAdmin = this.$sessao.usuario.tipoUsuario == "Administrador";
    this.abaSelecionada = "usuarios";

    this.$refs.listPlanosCliente.carregarItens();
    this.$refs.listPlanosFinalizados.carregarItens();
    this.$refs.listCreditosUsuario.carregarItens();
    this.$refs.listEventosUsuario.carregarItens();

  }
};
</script>

<style>
</style>